import { render, staticRenderFns } from "./form.vue?vue&type=template&id=3a21ff0c&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a21ff0c')) {
      api.createRecord('3a21ff0c', component.options)
    } else {
      api.reload('3a21ff0c', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=3a21ff0c&", function () {
      api.rerender('3a21ff0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/form.vue"
export default component.exports